import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLotId: null,
  selectedSentences: [],
  selectedTargetId: null,
  selectedTargetName: null,
  notifications: [],
  unreadCount: 0,
  studentIdForTTS: null,
  selectedModule: null,
  showMarkedSentencesTTT: false,
  showMarkedSentencesTTS: false,
  showMarkedSentencesDict: false,
  editSentences: false,
  editSentencesTTS: false,
};

const authSlice = createSlice({
  name: "studentDashboard",
  initialState,
  reducers: {
    setSelectedLotId(state, action) {
      state.selectedLotId = action.payload;
    },
    setSelectedSentences(state, action) {
      state.selectedSentences = action.payload;
    },
    setSelectedTargetId(state, action) {
      state.selectedTargetId = action.payload;
    },
    setSelectedTargetName(state, action) {
      state.selectedTargetName = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    setStudentIdForTTS: (state, action) => {
      state.studentIdForTTS = action.payload;
    },
    setSelectedModule: (state, action) => {
      state.selectedModule = action.payload;
    },
    setShowMarkedSentencesTTT: (state, action) => {
      state.showMarkedSentencesTTT = action.payload;
    },
    setShowMarkedSentencesTTS: (state, action) => {
      state.showMarkedSentencesTTS = action.payload;
    },
    setShowMarkedSentencesDict: (state, action) => {
      state.showMarkedSentencesDict = action.payload;
    },
    setEditSentences: (state, action) => {
      state.editSentences = action.payload;
    },
    setEditSentencesTTS: (state, action) => {
      state.editSentencesTTS = action.payload;
    }
  },
});

export const {
  setSelectedLotId,
  setSelectedSentences,
  setSelectedTargetId,
  setSelectedTargetName,
  setNotifications,
  setUnreadCount,
  setStudentIdForTTS,
  setSelectedModule,
  setShowMarkedSentencesTTT,
  setShowMarkedSentencesTTS,
  setShowMarkedSentencesDict,
  setEditSentences,
  setEditSentencesTTS
} =
  authSlice.actions;
export default authSlice.reducer;
